import NearBranchCard from '@/app/exam/license-test-course/[slug]/components/near-branch-card';
import { RECOMMEND_ENTRY_PARAM } from '@/lib/recommended-store';
import { NearStoreEntity } from '@/services/types/license-test-course.type';

interface Props {
  academyTitle: string;
  nearStores: NearStoreEntity[];
}

/**
 * 학원 상세 하단 — 학원 반경 20km 안의 드라이빙존 지점(최대 3곳).
 * 지점 상세는 학원 목록 추천 배너와 같은 진입(?from=academy)으로 열어 추천 요금제를 보여 준다.
 */
export default function AcademyNearBranches({
  academyTitle,
  nearStores,
}: Props) {
  return (
    <section className="desktop:web-w mobile-w desktop:mt-20 mx-auto mt-[30px]">
      <div className="desktop:mb-9 desktop:flex-row desktop:items-end desktop:justify-between mb-7 flex flex-col items-center gap-2">
        <div className="desktop:text-left text-center">
          <h2 className="typo-24 desktop:typo-28 text-level-2 leading-tight font-black">
            학원 가기 전, <br className="desktop:hidden" />
            <span className="text-font-blue">드라이빙존 시뮬레이터</span>로 감
            잡으세요
          </h2>
          <p className="typo-16 desktop:typo-18 text-level-4 mt-2 font-semibold">
            학원에서 부족한 연습도 가까운 드라이빙존에서 채울 수 있어요.
          </p>
        </div>
        <p className="typo-14 desktop:typo-18 text-font-grayblue shrink-0 font-semibold">
          {`* ${academyTitle} 기준 20km 이내`}
        </p>
      </div>
      <div className="desktop:grid-cols-3 grid grid-cols-1 gap-8">
        {nearStores.map((nearStore) => (
          <NearBranchCard
            key={nearStore.id}
            {...nearStore}
            distanceFrom="학원"
            query={`${RECOMMEND_ENTRY_PARAM.key}=${RECOMMEND_ENTRY_PARAM.value}`}
          />
        ))}
      </div>
    </section>
  );
}
